/* WRLD TAGS pin bundle, part 3 of 3: carousel and cart handoff.
   Load last. Adds methods to the class from wt-pin-bundle-b.js and
   registers the <pin-bundle> element.

   CART HANDOFF: this does not reimplement the theme's add to cart.
   HARD RULE (Sept 10, 2026): the pins ride along inside the SAME
   /cart/add request that adds the cap. The cart drawer app (UpCart)
   intercepts the Add to cart click itself, never submits the form, and
   posts the cap with its own fetch; click and submit listeners on the
   button or form never beat it (tested: pins never added, cap doubled on
   a second click). So installFetchHook() wraps window.fetch and, when pins
   are picked, merges them into any request to /cart/add. UpCart (or the
   theme) then gets one response with cap + pins and opens its own drawer,
   and the "buy a pin, get one free" discount applies. A bubble-phase
   submit listener only covers a plain non-ajax submit. Never go back to
   adding the pins in a separate request before the cap. The merge is
   idempotent (skips pins already in the body): one request can pass
   through two copies of the wrapper, which doubled every pin on Sept 10.

   TITLE RULE (Jaime, Sept 8 2026): the bundle title is a copy of the
   product title. matchTitle() copies the h1's font family, size, weight,
   style, transform, letter-spacing and line-height inline with !important,
   so whatever the product title looks like (set in assets/wt-header.css,
   product title section) the bundle heading looks the same. WT_TITLE_PX is
   only the fallback when no h1 is found. Never remove matchTitle: an app or
   theme h2 rule pushed the heading to 36px on Sept 7. */
(function () {
  'use strict';
  if (!window.WTPinBundle || customElements.get('pin-bundle')) return;

  var WT_TITLE_PX = 15;

  Object.assign(window.WTPinBundle.prototype, {

    matchTitle: function () {
      const t = this.querySelector('.wtb__title');
      const scope = this.closest('.shopify-section') || document;
      const h1 = scope.querySelector('h1') || document.querySelector('h1');
      if (!t) return;
      const c = h1 ? getComputedStyle(h1) : null;
      const set = function (p, v) { t.style.setProperty(p, v, 'important'); };
      if (c) {
        set('font-family', c.fontFamily);
        set('font-size', c.fontSize);
        set('font-weight', c.fontWeight);
        set('font-style', c.fontStyle);
        set('text-transform', c.textTransform);
        set('letter-spacing', c.letterSpacing);
        set('line-height', c.lineHeight);
      } else {
        set('font-size', WT_TITLE_PX + 'px');
        set('line-height', Math.round(WT_TITLE_PX * 1.4) + 'px');
      }
    },

    bind: function () {
      const self = this;
      this.matchTitle();
      window.addEventListener('resize', function () { self.matchTitle(); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.matchTitle(); });

      this.track.addEventListener('click', function (e) {
        const t = e.target.closest('[data-wtb-toggle]');
        if (t) {
          e.preventDefault(); e.stopPropagation();
          self.toggle(self.cards.indexOf(t.closest('[data-wtb-card]')));
          return;
        }
        const m = e.target.closest('[data-wtb-zoom]');
        if (m && self.lb) self.lb.open(self.cards.indexOf(m.closest('[data-wtb-card]')));
      });

      this.track.addEventListener('keydown', function (e) {
        const m = e.target.closest('[data-wtb-zoom]');
        if (m && self.lb && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          self.lb.open(self.cards.indexOf(m.closest('[data-wtb-card]')));
        }
      });

      const p = this.querySelector('[data-wtb-prev]');
      const x = this.querySelector('[data-wtb-next]');
      if (p) p.addEventListener('click', function () { self.page(-1); });
      if (x) x.addEventListener('click', function () { self.page(1); });
      this.track.addEventListener('scroll', function () { self.syncArrows(); });
      window.addEventListener('resize', function () { self.syncArrows(); });
    },

    page: function (dir) {
      const first = this.cards[0];
      if (!first) return;
      const per = parseInt(getComputedStyle(this).getPropertyValue('--wtb-per-view'), 10) || 4;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 10;
      this.track.scrollBy({
        left: dir * (first.getBoundingClientRect().width + gap) * per, behavior: 'smooth'
      });
    },

    syncArrows: function () {
      const p = this.querySelector('[data-wtb-prev]');
      const x = this.querySelector('[data-wtb-next]');
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (p) p.disabled = this.track.scrollLeft <= 2;
      if (x) x.disabled = this.track.scrollLeft >= max;
    },

    hookForm: function () {
      const self = this;
      const scope = this.closest('.shopify-section') || document;
      // Start from the Add to cart BUTTON: the product column has more than one form[action*="/cart/add"].
      const btn = scope.querySelector('.product-form__submit[name="add"]') || document.querySelector('.product-form__submit[name="add"]');
      let form = null;
      if (btn) {
        form = btn.form || null;
        const fid = btn.getAttribute('form');
        if (!form && fid) form = document.getElementById(fid);
      }
      if (!form) {
        const forms = Array.from(scope.querySelectorAll('form[action*="/cart/add"]'));
        form = forms.find(function (f) { return f.querySelector('[name="add"]'); }) || forms[0]
          || document.querySelector('form[action*="/cart/add"]');
      }
      this.form = form;
      this.submitBtn = btn || (form && form.querySelector('[name="add"]'));

      // 1. The real hook: window.fetch. Whoever adds the cap (UpCart, the theme) posts to /cart/add(.js);
      //    the picked pins ride along in that same request. Installed now and re-checked on every
      //    press of the button, so this wrapper is always the outermost one at click time.
      this.installFetchHook();
      if (this.submitBtn) {
        this.submitBtn.addEventListener('pointerdown', function () { self.installFetchHook(); }, true);
        this.submitBtn.addEventListener('keydown', function () { self.installFetchHook(); }, true);
      }

      // 2. Fallback for a plain (non-ajax) form submit: nobody called preventDefault, so nobody
      //    fetched. Add the pins first, then let the form go through on its own.
      if (this.form) {
        this.form.addEventListener('submit', function (e) {
          if (e.defaultPrevented || self.passthrough || self.picked.size === 0) return;
          e.preventDefault();
          self.addItems(self.pinItems()).then(function () {
            self.picked.clear();
            self.render();
            self.passthrough = true;
            if (self.form.requestSubmit) self.form.requestSubmit(self.submitBtn || undefined); else self.form.submit();
            self.passthrough = false;
          }).catch(function (err) { self.showError(err); });
        });
      }
    },

    pinItems: function () {
      const self = this;
      return Array.from(this.picked).map(function (i) { return { id: self.pins[i].variant, quantity: 1 }; });
    },

    showError: function (e) {
      const err = this.querySelector('[data-wtb-error]');
      if (!err) return;
      err.hidden = false;
      err.textContent = (e && e.message) || 'Those items could not be added. Please try again.';
    },

    installFetchHook: function () {
      const self = this;
      if (window.fetch && window.fetch.__wtPinBundle) return;
      const orig = window.fetch;
      if (typeof orig !== 'function') return;
      const wrapped = function (input, init) {
        try {
          const url = typeof input === 'string' ? input : ((input && input.url) || '');
          if (/\/cart\/add(\.js)?(\?|$)/.test(url) && self.picked.size > 0 && !self.passthrough) {
            const merged = self.mergeBody(init && init.body, init && init.headers);
            if (merged) {
              init = Object.assign({}, init, { body: merged.body, headers: merged.headers });
              const p = orig.call(this, input, init);
              p.then(function (res) {
                if (res && res.ok) { self.picked.clear(); self.render(); }
              }).catch(function () {});
              return p;
            }
          }
        } catch (e) {}
        return orig.call(this, input, init);
      };
      wrapped.__wtPinBundle = true;
      window.fetch = wrapped;
    },

    // Turn whatever body the cap was posted with into a JSON {items:[cap, ...pins]} body.
    mergeBody: function (body, headers) {
      let items = null;
      const pins = this.pinItems();
      if (typeof body === 'string') {
        try {
          const j = JSON.parse(body);
          if (j && Array.isArray(j.items)) items = j.items;
          else if (j && j.id) items = [j];
        } catch (e) {
          items = this.itemsFromParams(new URLSearchParams(body));
        }
      } else if (body && typeof FormData !== 'undefined' && body instanceof FormData) {
        items = this.itemsFromParams(body);
      } else if (body && typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        items = this.itemsFromParams(body);
      }
      if (!items || !items.length) return null;
      // Idempotent: the fetch chain can pass one request through this wrapper twice (UpCart wraps
      // fetch over ours, then a fresh copy of ours goes on top). If the pins are already in the
      // body, do nothing. Sept 10, 2026: Jaime got 2 of each pin because of this.
      const pending = pins.filter(function (pin) {
        return !items.some(function (it) { return String(it.id) === String(pin.id); });
      });
      if (!pending.length) return null;
      const h = {};
      if (headers) {
        if (typeof Headers !== 'undefined' && headers instanceof Headers) headers.forEach(function (v, k) { h[k] = v; });
        else Object.keys(headers).forEach(function (k) { h[k] = headers[k]; });
      }
      Object.keys(h).forEach(function (k) { if (k.toLowerCase() === 'content-type') delete h[k]; });
      h['Content-Type'] = 'application/json';
      if (!Object.keys(h).some(function (k) { return k.toLowerCase() === 'accept'; })) h['Accept'] = 'application/json';
      return { body: JSON.stringify({ items: items.concat(pending) }), headers: h };
    },

    itemsFromParams: function (params) {
      const id = params.get('id');
      if (!id) return null;
      const item = { id: id, quantity: parseInt(params.get('quantity'), 10) || 1 };
      const sp = params.get('selling_plan');
      if (sp) item.selling_plan = sp;
      params.forEach(function (v, k) {
        const m = /^properties\[(.+)\]$/.exec(k);
        if (m) { item.properties = item.properties || {}; item.properties[m[1]] = v; }
      });
      return [item];
    },

    addItems: function (items) {
      if (!items.length) return Promise.resolve();
      const base = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
      this.passthrough = true;
      const p = fetch(base + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      this.passthrough = false;
      return p.then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (j) {
          if (!res.ok || j.status) {
            throw new Error(j.description || j.message || 'Could not add to your cart.');
          }
          return j;
        });
      });
    },

    addPins: function () { return this.addItems(this.pinItems()); }
  });

  customElements.define('pin-bundle', window.WTPinBundle);
})();
